module.exports = __webpack_public_path__ + "img/infibo-review-screenshot-en.a752552a.png";